module.exports = __webpack_public_path__ + "img/nexticon.a29c2568.svg";